import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { ValidatorContract } from "utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "utils/Environment";
import { ethers } from "ethers";

const SendClaimBatch = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const validatorAddress = Environment.ValidatorContract;
  const validatorContract = ValidatorContract(validatorAddress, web3);

  const claimBatch = useCallback(
    async (tokenIds, amounts, nextClaimPeriods, deadline, signature) => {
      try {
        const transaction = await validatorContract.methods
          .claimBatch(tokenIds, amounts, nextClaimPeriods, deadline, signature)
          .send({ from: account });

        console.log("Claim Batch transaction successful: ", transaction);

        return transaction;
      } catch (error) {
        console.error(`Error during claim batch transaction: `, error);
        throw error;
      }
    },
    [validatorContract, account]
  );

  return { claimBatch: claimBatch };
};

export default SendClaimBatch;
